import React from 'react'
import ProductCard from '../ProductCard'
import { ProductCardProps, ProductOptions } from '../types.d'
import renderer from 'react-test-renderer'
import { render, screen } from '@testing-library/react'

const product: ProductOptions = {
  imageResolutions: [
    {
      desktop: [
        {
          url: 'https://placekitten.com/640/360'
        }
      ]
    }
  ]
}
const baseProps: ProductCardProps = {
  bgColor: 'bg-white',
  cardBorderColor: 'light',
  toggleSwitch2: true,
  products: [product],
  textAlignment: 'center'
}

describe('ProductCard UI Tests', () => {
  it('Renders correctly', () => {
    //@ts-ignore
    const tree = renderer.create(<ProductCard {...baseProps} />).toJSON()
    expect(tree).toMatchSnapshot()
  })
  it('Should render the card as a div, with only the image when only the base props are passed', () => {
    render(<ProductCard {...baseProps} />)
    const card = screen.getByTestId('ProductCard-1')
    expect(card.nodeName.toLowerCase()).toBe('div')
    expect(screen.getByTestId('mds-imageResolutions')).toBeTruthy()
  })
  it('Should display the card as a link when there is a ctaLink defined in the product object', () => {
    render(
      <ProductCard {...baseProps} products={[{ ...product, ctaLink: '/' }]} />
    )
    expect(screen.getByRole('link')).toBeTruthy()
    expect(screen.getByTestId('mds-imageResolutions')).toBeTruthy()
  })
  it('Should display the sectionHeading, sectionDescription, and ctaLabel when they are passed as props', () => {
    const sectionHeading = 'Test Heading'
    const sectionDescription = 'Test product description'
    const ctaLabel = 'Test CTA Text'
    render(
      <ProductCard
        {...baseProps}
        ctaLabel={ctaLabel}
        products={[
          { ...product, ctaLink: '/', sectionHeading, sectionDescription }
        ]}
      />
    )
    expect(screen.getByRole('heading', { level: 4 })).toBeTruthy()
    expect(screen.getByText(sectionDescription)).toBeTruthy()
    expect(screen.getByText(ctaLabel)).toBeTruthy()
  })
})
